document.addEventListener("DOMContentLoaded", function () {
  const filterForm = document.querySelector("#FacetFiltersForm");
  const productGridSelector = ".Collection_product_grid_inner_new";

  function scrollToProductGridWhenReady() {
    const grid = document.querySelector(productGridSelector);
    if (!grid) return;

    // Wait for grid to be visibly rendered
    let attempts = 0;
    const maxAttempts = 10;
    const checkRendered = setInterval(() => {
      const rect = grid.getBoundingClientRect();
      if (grid.offsetHeight > 0 && rect.top !== 0 || attempts >= maxAttempts) {
        clearInterval(checkRendered);
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const offsetTop = rect.top + scrollTop - 200;

        window.scrollTo({ top: offsetTop, behavior: "smooth" });
      }
      attempts++;
    }, 100);
  }

  function observeGridUpdateAndScroll() {
    const gridWrapper = document.querySelector(productGridSelector);
    if (!gridWrapper) return;

    const observer = new MutationObserver((mutations, obs) => {
      if (gridWrapper.innerHTML.trim().length > 0) {
        scrollToProductGridWhenReady();
        obs.disconnect();
      }
    });

    observer.observe(gridWrapper, { childList: true, subtree: true });
  }

  if (filterForm) {
    filterForm.addEventListener("change", observeGridUpdateAndScroll);
  }

  document.body.addEventListener("click", function (e) {
    const target = e.target;
    if (target.closest("facet-remove") || target.classList.contains("icon-close-small")) {
      observeGridUpdateAndScroll();
    }
  });
});
